import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { SimulatorService } from '../../../../../pre-simulator/services/simulator/simulator.service';
import { UserDataService } from '../../../../../shared/services/user-data/user-data.service';
import { ConfirmationService } from '../../../../../vass-core/components/modal/confirmation.service';
import { LifeInsuranceComponent } from '../../../../components/modals/life-insurance/life-insurance.component';
import { AppraisalModel } from '../../../../models/appraisal.model';
import { MortgageService } from '../../../../services/mortgage/mortgage.service';

@Component({
  selector: 'app-appraisal-result',
  templateUrl: './appraisal-result.component.html',
  styleUrls: ['./appraisal-result.component.scss'],
  standalone: false,
})
export class AppraisalResultComponent implements OnInit, OnChanges {
  @Input() appraisal: AppraisalModel;

  public appraisalInfoWithoutChecks: any;
  public isAppraisalEmpty: any;
  public isAppraisalCRMEmpty: any;
  public province: any;
  private subscription = new Subscription();

  constructor(
    private _simulatorService: SimulatorService,
    private confirmationService: ConfirmationService,
    private mortgageService: MortgageService,
    private userData: UserDataService,
  ) {}

  ngOnInit() {
    // this.checkLifeInsurance();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appraisal && changes.appraisal.currentValue) {
      this.findProvince();
      this.appraisalInfoWithoutChecks = Object.create(
        this.appraisal.mortgagesAppraisalData,
      );
      delete this.appraisalInfoWithoutChecks.simpleNote;
      delete this.appraisalInfoWithoutChecks.appraisal;
      const isAppraisalAddressEmpty = Object.values(
        this.appraisalInfoWithoutChecks.appraisalAddress,
      ).every((x) => x === null || x === '');
      const isAppraisalInfoWithoutChecksEmpty = Object.values(
        this.appraisalInfoWithoutChecks.appraisalAddress,
      ).every((x) => x === null || x === '');
      this.isAppraisalEmpty =
        isAppraisalAddressEmpty && isAppraisalInfoWithoutChecksEmpty;
      this.isAppraisalCRMEmpty = Object.values(
        this.appraisal.mortgagesAppraisalCrmData,
      ).every((x) => x === null || x === '');
    }
  }

  private findProvince() {
    this._simulatorService.getCCAA().subscribe(
      (data) => {
        this.province = data.find(
          (r) => r.id === this.appraisal.mortgagesAppraisalData.appraisalAddress.province,
        );
      },
      (err) => {},
    );
  }

  checkLifeInsurance() {
    this.subscription.add(
      this.mortgageService
        .getLifeInsurance(this.userData.getUserData().id)
        .subscribe((data) => {
          if (data === 'null') {
            this.showModalLifeInsurance();
          }
        }),
    );
  }

  showModalLifeInsurance() {
    const options: Object = {
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm({
      component: LifeInsuranceComponent,
      options: options,
      accept: (data) => {
        console.log(data);
      },
      reject: () => {},
    });
  }
}
